var _style, _polyline, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNxp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "nxp-logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 93 32",
    width: 372,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .nxpsvglogoN {\nfill: #fca600;\n    }\n    .nxpsvglogoP {\nfill: #69ca00;\n    }\n    .nxpsvglogoX {\nfill: #0eafe0;\n    }\n  ")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "nxpLogoTitle"
  }, "NXP") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "nxpLogoTitle"
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "nxpsvglogoN",
    points: "26,0 26,19.3 9.7,0 0,0 0,32 9.7,32 9.7,12.7 26,32 35.7,16 26,0 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "nxpsvglogoX",
    d: "M53.4,32l-6.5-10.6L40.4,32H28.9l9.7-16L28.9,0h11.4l6.5,10.6L53.4,0h11.4l-9.7,16l9.7,16H53.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "nxpsvglogoP",
    d: "M81.6,0H67.8l-9.7,16l9.7,16l0,0v-7.1h16.3c6.8,0,8.9-5.5,8.9-10.2v-3.8C93,4.7,90.8,0,81.6,0 M84,12.9  c0,1.9-0.9,4.1-3.1,4.1h-13V7.9H80c2.9,0,4,1.2,4,3.4C84,11.3,84,12.9,84,12.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNxp);
export default __webpack_public_path__ + "static/media/nxp.2dfc7275a362f858c72536a720985c4e.svg";
export { ForwardRef as ReactComponent };